import React, { useContext, useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import {
  GetActiveTasksForConfigurableTelerikGrid
} from "../../../../../services/api/task-telerik-api";
import { ConfigurableTaskGrid } from "./configurable-task-grid";
import { ConfigurableTaskGridLegacy } from "./configurable-task-grid-legacy";
import { ModifyConfigurableTaskData } from "./configurable-task-util";
import { TaskMainHeader } from "../common-components/task-main-header";
import { TaskListSkeleton } from "../common-components/tasklist-skeleton";
import { LoginContext } from "../../../../../services/api/authentication-api";
import "../common-components/tasks.scss";
import { useLocation, useHistory } from "react-router-dom";

export const ConfigurableTaskMain = () => {
  const [isLegacyGrid, setIsLegacyGrid] = useState(true);
  const [data, setData] = useState({
    data: null,
    isLoading: true,
  });
  const [type, setType] = useState("Active");
  const user = useContext(LoginContext);
  const labels = user?.currentUser?.objectLabels;
  const history = useHistory();
  const location = useLocation();
  const [taskToOpen, setTaskToOpen] = useState(null);
  const canCreate =
    (user?.currentUser?.privileges?.["Task Management"]?.Add ?? false);
    //  ||
    // (user?.currentUser?.privileges?.["Document Collaboration"]?.Add ?? false);
  useEffect(() => {
    // Check if we're returning from task form and should open a modal
    if (location.state?.openModal && location.state?.taskId) {
      setTaskToOpen(location.state.taskId);
      // Replace history entry to remove the state
      history.replace(location.pathname, {});
    }
  }, [location, history]);
  const GetTasks = async () => {
    try {
      setData((prev) => ({
        ...prev,
        isLoading: true,
      }));

      let result = await GetActiveTasksForConfigurableTelerikGrid(type);
      let checkLegacyGrid = result?.data?.isLegacy ?? false;
      setIsLegacyGrid(checkLegacyGrid);
      let modifiedResult = await ModifyConfigurableTaskData(
        result?.data?.data,
        user?.currentUser?.department?.DateFormatID
      );

      setData((prev) => ({
        ...prev,
        data: modifiedResult,
        allColumns: result?.data.allColumns,
        columnDefinitions: result?.data.columnDefinitions,
        isLoading: false,
      }));
    } catch (e) {
      console.log("Error [GetActiveTasksForTelerikGrid] => ", e);
    }
  };

  useEffect(() => {
    GetTasks();
  }, [type]);

  return (
    <div className="task-main">
      <Helmet>
        <title> TRIYO · {labels?.TaskPlural ?? 'Tasks'} </title>
      </Helmet>
      <TaskMainHeader data={data} type={type} setType={setType} canCreate={canCreate} labels={labels} />
      {data.isLoading ? (
        <TaskListSkeleton />
      ) : (
        <div className="task-tab-grid dashboard-container-shadow">
          {isLegacyGrid ? (
            <ConfigurableTaskGridLegacy data={data} GetTasks={GetTasks} type={type} />
          ) : (
                <ConfigurableTaskGrid
                  data={data}
                  GetTasks={GetTasks}
                  type={type}
                  taskToOpen={taskToOpen}
                  setTaskToOpen={setTaskToOpen}
                />
          )}
        </div>
      )}
    </div>
  );
};
